import { useState, useEffect } from "react";

const memoryStore = {};

export function clearPersistedState() {
  for (const k in memoryStore) {
    delete memoryStore[k];
  }
}

export function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() =>
    key in memoryStore ? memoryStore[key] : defaultValue
  );

  useEffect(() => {
    memoryStore[key] = value;
  }, [key, value]);

  return [value, setValue];
}